import axios from "axios";
import i18n from './../i18n';

export default {
    fetchCourse(id) {
        return axios.get('courses/' + id + '?expand=ages,lessonscount,ordered,freeLessonsCount,freeLessonsIds,isAdditionalPackage,authors,lastCompletedLessonDate,restrictedByExpiredSubscription,restrictedToFreeSubscription,restrictedByPartialPayDebt')
            .then(response => {
                return response.data
            })
    },

    fetchCourseBySlug(slug) {
        return axios.get('courses/by-slug/' + slug + '?expand=ages,lessonscount,ordered,freeLessonsCount,freeLessonsIds,isAdditionalPackage,authors,lastCompletedLessonDate,restrictedByExpiredSubscription,restrictedToFreeSubscription,restrictedByPartialPayDebt')
            .then(response => {
                return response.data
            })
    },

    fetchCourses() {
        return axios.get('courses/list?expand=ordered,freeLessonsCount,isAdditionalPackage')
            .then(response => {
                return response.data
            })
    },

    fetchCoursesWithFilter(ageId, languageId, difficultyId) {
        let query = {'expand': 'ages,lessonscount,ordered,freeLessonsCount,isAdditionalPackage', 'sort': 'idcourse'}
        if (ageId) query['age'] = ageId
        if (languageId) query['idlanguage'] = languageId
        if (difficultyId) query['difficulty'] = difficultyId

        const queryParams = new URLSearchParams(query);
        let uri = 'courses?' + queryParams.toString();
        return axios.get(uri)
            .then(response => {
                return response.data
            })
    },

    fetchCourseTest(id) {
        return axios.get('courses/' + id)
            .then(response => {
                return response.data
            })
    },

    getDifficultyName(id) {
        if (id === 3) return "High";
        if (id === 2) return "Medium";
        if (id === 1) return "Low";
        return null;
    },

    getAgeName(id) {
        if (id === 1) return i18n.t('preschooler');
        if (id === 2) return i18n.t('schoolboy_1_4_class');
        if (id === 3) return i18n.t('parent');
        //if (id === 4) return "12-17 лет";
        return null;
    },

    getAllAgeNames() {
        return i18n.t('preschooler') + ", " + i18n.t('schoolboy_1_4_class') + ", " + i18n.t('parent')
    },

    getLanguageName(id) {
        if (id === 1) return i18n.t('english');
        if (id === 2) return i18n.t('spanish');
        if (id === 3) return i18n.t('german');
        if (id === 4) return i18n.t('french');
        if (id === 5) return i18n.t('chinese');
        if (id === 6) return i18n.t('russian');
        return null;
    },

    fetchComments(id) {
        return axios.get(`courses/${id}/comments`)
            .then(response => {
                return response.data;
            });
    },

    createComment(id, comment) {
        return axios.post(`courses/${id}/comments`, { comment })
            .then(response => {
                return response.data;
            });
    },

    fetchOnlineTeacherComments() {
        return axios.get(`comments/online-teacher`)
            .then(response => {
                return response.data;
            });
    },

    createOnlineTeacherComment(comment) {
        return axios.post(`comments/online-teacher`, { comment })
            .then(response => {
                return response.data;
            });
    },

    removeMyRecurrent(courseId) {
        return axios.post('usercourse/remove-my-recurrent', {course_id: courseId})
            .then(response => {
                return response.data
            })
    },
}
